import { render } from "./HeroScene.vue?vue&type=template&id=a2b1ae04&scoped=true"
import script from "./HeroScene.vue?vue&type=script&lang=js"
export * from "./HeroScene.vue?vue&type=script&lang=js"

import "./HeroScene.vue?vue&type=style&index=0&id=a2b1ae04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2b1ae04"]])

export default __exports__